<template>
  <router-link
    :to="lang ? '/' + lang + '/contacts' : '/contacts'"
    class="seasidetms_header_contacts_link"
  >
    <span
      class="seasidetms_header_contacts_link-icon seasidetms-icon-phone-alt"
    ></span>
  </router-link>
</template>

<script>
export default {
  name: 'ContactsLinkMobile',
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.seasidetms_header_contacts_link-icon {
  display: block;
  font-size: 27px;
}
@media only screen and (max-width: 1024px) {
  .seasidetms_header_contacts_link {
    margin-top: 44px;
  }
}
@media only screen and (max-width: 768px) {
  .seasidetms_header_contacts_link {
    margin-top: 23px;
  }
}
@media only screen and (max-width: 360px) {
  .header_mid .seasidetms_header_contacts_link {
    margin-right: 10px !important;
  }
}
</style>
